import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _createClass from 'babel-runtime/helpers/createClass';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n     \tquery collectionQuery {\n\t\t\t\t \n\t\t\t\t\tcollections(first: 10) {\n    edges {\n      node {\n        id\n        title\n        products(first: 50) {\n          edges {\n            node {\n              id\n\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\thandle\n\t\t\t\t\t\t\tonlineStoreUrl\n\t\t\t\t\t\t\ttags\n              priceRange {\n                minVariantPrice {\n                  currencyCode\n                  amount\n                }\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\timages(first: 2) {\n     \t           edges {\n     \t             node {\n     \t               altText\n     \t               thumbnailImg:transformedSrc(maxWidth: 100, maxHeight: 120, crop:CENTER)\n     \t               productImg:transformedSrc(maxWidth: 800, maxHeight: 960, crop:CENTER)\n     \t             }\n     \t           }\n     \t         }\n            }\n          }\n        }\n      }\n    }\n  } \n\t}}\n\t\t'], ['\n     \tquery collectionQuery {\n\t\t\t\t \n\t\t\t\t\tcollections(first: 10) {\n    edges {\n      node {\n        id\n        title\n        products(first: 50) {\n          edges {\n            node {\n              id\n\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\thandle\n\t\t\t\t\t\t\tonlineStoreUrl\n\t\t\t\t\t\t\ttags\n              priceRange {\n                minVariantPrice {\n                  currencyCode\n                  amount\n                }\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\timages(first: 2) {\n     \t           edges {\n     \t             node {\n     \t               altText\n     \t               thumbnailImg:transformedSrc(maxWidth: 100, maxHeight: 120, crop:CENTER)\n     \t               productImg:transformedSrc(maxWidth: 800, maxHeight: 960, crop:CENTER)\n     \t             }\n     \t           }\n     \t         }\n            }\n          \n        \n      }\n    }\n  } \n\t}}\n\t\t']);

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Query } from 'react-apollo';
import { ApolloProvider } from 'react-apollo';
import gql from 'graphql-tag';
import PageinateGroup from '../pageinate/pageinate_group.js';
import './collections.css';
import Collection from './collection.js';

var _ref2 = React.createElement(
	'div',
	{ className: 'loading' },
	'Loading...',
	React.createElement(
		'div',
		{ className: 'loader' },
		React.createElement('span', { className: 'inner1' }),
		React.createElement('span', { className: 'inner2' }),
		React.createElement('span', { className: 'inner3' })
	)
);

var AllCollections = function (_Component) {
	_inherits(AllCollections, _Component);

	_createClass(AllCollections, [{
		key: 'getCollections',
		value: function getCollections() {
			return gql(_templateObject);
		}
	}]);

	function AllCollections() {
		_classCallCheck(this, AllCollections);

		var _this = _possibleConstructorReturn(this, (AllCollections.__proto__ || Object.getPrototypeOf(AllCollections)).call(this));

		_this.state = {
			display_num: 50,
			filter_tag: null,
			current_page: 1
		};
		_this.getCollections = _this.getCollections.bind(_this);
		_this.queryCompleted = _this.queryCompleted.bind(_this);

		return _this;
	}

	_createClass(AllCollections, [{
		key: 'queryCompleted',
		value: function queryCompleted(data) {
			console.log('query completed', data.collections.edges);

			this.setState({ collections: data.collections.edges });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				'div',
				null,
				React.createElement(
					Query,
					{
						query: this.getCollections(),
						onCompleted: this.queryCompleted
					},
					function (_ref) {
						var loading = _ref.loading,
						    error = _ref.error,
						    data = _ref.data;

						if (!loading) {
							console.log('in quer', data, error, loading);
							var _state = _this2.state,
							    current_page = _state.current_page,
							    display_num = _state.display_num;

							return data.collections.edges.map(function (collection) {
								return React.createElement(Collection, {
									collection: collection.node,
									display_num: display_num,
									current_page: current_page
								});
							});
						} else {
							return _ref2;
						}
					}
				)
			);
		}
	}]);

	return AllCollections;
}(Component);

export default AllCollections;